export default __webpack_public_path__ + "static/media/img_4_thumb.4803c293.JPG";